import React from 'react';
import PageWithCard from '../../components/infrastructure/PageWithCard';

const Resources = () => {
    return (
        <PageWithCard heading="Resources">
            <table className="table-auto w-full border">
                <thead className="w-full">
                    <tr>
                        <th className="px-2 py-3 border w-[10%]">Sr No.</th>
                        <th className="px-2 py-3 border w-[60%]">Name</th>
                        <th className="px-2 py-3 border w-[30%]">Link</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="px-2 py-3 border">1</td>
                        <td className="px-2 py-3 border">
                            Product Bulk Upload Format
                        </td>
                        <td className="px-2 py-3 border">
                            {' '}
                            <a
                                className="text-indigo-500 underline"
                                href="https://s3.ap-south-1.amazonaws.com/media.rajpath.in/sample_file_product_bulk_upload.csv"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Download Now
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <td className="px-2 py-3 border">2</td>
                        <td className="px-2 py-3 border">
                            Catalog bulk upload format
                        </td>
                        <td className="px-2 py-3 border">
                            {' '}
                            <a
                                className="text-indigo-500 underline"
                                href="https://s3.ap-south-1.amazonaws.com/media.rajpath.in/sample_file_catalog_bulk_upload.csv"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Download Now
                            </a>
                        </td>
                    </tr>                    
                </tbody>
            </table>
        </PageWithCard>
    );
};

export default Resources;
